import styled from 'styled-components/native';
import style, { hpx, wpx } from '../../styles';

export const ButtonContainer = styled.View`
  padding: ${hpx(12)} ${wpx(16)};
  background-color: transparent;
`;

export const Container = styled.TouchableOpacity`
  background: ${props => props.theme.colors.primary};
  height: ${hpx(56)};
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${hpx(12)} ${wpx(16)};
  border-radius: 16px;
  shadow-color: ${props => props.theme.colors.primary};
  shadow-offset: 0px 4px;
  shadow-opacity: 0.3;
  shadow-radius: 12px;
  elevation: 8;
`;

export const TextContainer = styled.View`
  background-color: rgba(255, 255, 255, 0.2);
  width: 36px;
  height: 36px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
`;

export const Count = styled.Text`
  font-size: ${style.fonts.small};
  color: ${props => props.theme.colors.secondary};
  font-family: ${style.fontName.ubuntuBold};
`;

export const Text = styled.Text`
  font-size: ${style.fonts.small};
  color: ${props => props.theme.colors.secondary};
  font-family: ${style.fontName.ubuntuBold};
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const Total = styled.Text`
  font-size: ${style.fonts.small};
  color: ${props => props.theme.colors.secondary};
  font-family: ${style.fontName.ubuntuBold};
`;
